import { useEffect, useState } from "react";
import { isValidDateObject } from "../services/dateTimePreferences";

export function usePickerDraftValue(
    value: string | null,
    toPickerDate: (value: string | null) => Date | null,
    toFieldValue: (date: Date | null) => string | null,
    onChange: (value: string | null) => void
) {
    const [draft, setDraft] = useState<Date | null>(null);

    useEffect(() => {
        if (value !== null) setDraft(null);
    }, [value]);

    const handlePickerChange = (date: Date | null) => {
        if (date !== null && !isValidDateObject(date)) {
            setDraft(date);
            onChange(null);
            return;
        }

        setDraft(null);
        onChange(toFieldValue(date));
    };

    return {
        pickerValue: draft !== null && value === null ? draft : toPickerDate(value),
        handlePickerChange,
    };
}
